import { API } from "../config/axiosConfig";

const adminMarketPlace = {
  // Fetch listings with pagination & filters
  getListings: async (paramsObj) => {
    try {
      // Remove undefined, null, or empty string params
      const filteredParams = Object.fromEntries(
        Object.entries(paramsObj).filter(
          ([, value]) => value !== undefined && value !== null && value !== ""
        )
      );

      const response = await API.get("/api/cards/admin/listings/", {
        params: filteredParams,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Failed to fetch listings",
      };
    }
  },

  // Update card listing status (approve/reject)
  updateListingStatus: async (listingId, status, rejectionReason = "") => {
    try {
      const payload = {
        status,
         rejection_reason: rejectionReason ,
      };

      const response = await API.put(
        `/api/cards/card-listing/${listingId}/status/`,
        payload
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          `Failed to update status for listing ${listingId}`,
      };
    }
  },


    // Explicit approve listing function
  approveListing: async (listingId) => {
    try {
      const payload = { status: "approved" };

      const response = await API.put(
        `/api/cards/card-listing/${listingId}/status/`,
        payload
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          `Failed to approve listing ${listingId}`,
      };
    }
  },
};

export default adminMarketPlace;
